import React from 'react';
import { Chip, IconButton, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface DraftHeaderProps {
  status: string;
  isApproved: boolean;
  isGenerated: boolean;
  onBack: () => void;
}

const DraftHeader: React.FC<DraftHeaderProps> = ({ status, isApproved, isGenerated, onBack }) => (
  <Stack direction="row" spacing={2} alignItems="center" mb={3}>
    <IconButton onClick={onBack}>
      <ArrowBackIcon />
    </IconButton>
    <Typography variant="h4" component="h1">
      Schema Draft Workspace
    </Typography>
    <Chip
      label={`Status: ${status}`}
      color={isApproved ? 'success' : isGenerated ? 'info' : 'default'}
    />
  </Stack>
);

export default DraftHeader;
